import CalendarCheckColor from './CalendarCheckColour.svg';
import CalendarCheckDark from './CalendarCheckDark.svg';
import CalendarCheckLight from './CalendarCheckLight.svg';
export const calendarCheck = { color: CalendarCheckColor, dark: CalendarCheckDark, light: CalendarCheckLight };
//# sourceMappingURL=index.js.map